/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "table": {
      "emptyText": "No Data",
      "confirmFilter": "Confirm",
      "resetFilter": "Reset",
      "clearFilter": "All",
      "sumText": "Sum",
      "retry": "Retry"
    }
  },
  "de-DE": {
    "table": {
      "emptyText": "Keine Daten",
      "confirmFilter": "Bestätigen",
      "resetFilter": "Zurücksetzen",
      "clearFilter": "Alle",
      "sumText": "Gesamt",
      "retry": "Neuversuch"
    }
  },
  "es-ES": {
    "table": {
      "emptyText": "Sin datos",
      "confirmFilter": "Confirmar",
      "resetFilter": "Reestablecer",
      "clearFilter": "Todos",
      "sumText": "Suma",
      "retry": "Reintentar"
    }
  },
  "fr-FR": {
    "table": {
      "emptyText": "Aucune donnée",
      "confirmFilter": "Confirmer",
      "resetFilter": "Réinitialiser",
      "clearFilter": "Tout",
      "sumText": "Somme",
      "retry": "Réessayer"
    }
  },
  "id-ID": {
    "table": {
      "emptyText": "Tidak ada data",
      "confirmFilter": "Konfirmasi",
      "resetFilter": "Atur ulang",
      "clearFilter": "Semua",
      "sumText": "Jumlah",
      "retry": "Coba lagi"
    }
  },
  "it-IT": {
    "table": {
      "emptyText": "Nessun dato",
      "confirmFilter": "Conferma",
      "resetFilter": "Reimposta",
      "clearFilter": "Tutti",
      "sumText": "Somma",
      "retry": "Riprova"
    }
  },
  "jp-JP": {
    "table": {
      "emptyText": "データなし",
      "confirmFilter": "確認",
      "resetFilter": "リセット",
      "clearFilter": "すべて",
      "sumText": "合計",
      "retry": "再試行"
    }
  },
  "ko-KO": {
    "table": {
      "emptyText": "데이터 없음",
      "confirmFilter": "확인",
      "resetFilter": "재설정",
      "clearFilter": "모두",
      "sumText": "합계",
      "retry": "재시도"
    }
  },
  "nl-NL": {
    "table": {
      "emptyText": "Geen gegevens",
      "confirmFilter": "Bevestigen",
      "resetFilter": "Resetten",
      "clearFilter": "Alle",
      "sumText": "Totaal",
      "retry": "Opnieuw proberen"
    }
  },
  "pl-PL": {
    "table": {
      "emptyText": "Brak danych",
      "confirmFilter": "Potwierdź",
      "resetFilter": "Reset",
      "clearFilter": "Wszyscy",
      "sumText": "Suma",
      "retry": "Spróbuj ponownie"
    }
  },
  "pt-PT": {
    "table": {
      "emptyText": "Sem dados",
      "confirmFilter": "Confirmar",
      "resetFilter": "Redefinir",
      "clearFilter": "Todos",
      "sumText": "Soma",
      "retry": "Repetir"
    }
  },
  "ru-RU": {
    "table": {
      "emptyText": "Нет данных",
      "confirmFilter": "Подтвердить",
      "resetFilter": "Сброс",
      "clearFilter": "Все",
      "sumText": "Сумма",
      "retry": "Повторить"
    }
  },
  "tr-TR": {
    "table": {
      "emptyText": "Veri yok",
      "confirmFilter": "Onayla",
      "resetFilter": "Sıfırla",
      "clearFilter": "Tümü",
      "sumText": "Özet",
      "retry": "Yeniden Dene"
    }
  },
  "vi-VN": {
    "table": {
      "emptyText": "Không có dữ liệu",
      "confirmFilter": "Xác nhận",
      "resetFilter": "Đặt lại",
      "clearFilter": "Tất cả",
      "sumText": "Tổng cộng",
      "retry": "Thử lại"
    }
  },
  "zh-CN": {
    "table": {
      "emptyText": "无数据",
      "confirmFilter": "确认",
      "resetFilter": "重置",
      "clearFilter": "全部",
      "sumText": "总和",
      "retry": "重试"
    }
  },
  "zh-TW": {
    "table": {
      "emptyText": "無資料",
      "confirmFilter": "確認",
      "resetFilter": "重設",
      "clearFilter": "所有",
      "sumText": "總和",
      "retry": "重試"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
